// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3rkYP","label":"Completed_label__3_zxC"};